import { MDBCol, MDBRow } from 'mdb-react-ui-kit'
import React from 'react'
import BrandLogo from "../assets/images/brandlogo.png";

function GymFooter({ footerData, bussinessinfo }) {
    return (
        <>
            <div className='footer-section text-white mt-4' style={{
                // opacity: footerData.isactive ? 1 : 0.6,
                backgroundColor: footerData?.backgroundcolor || '#2c3e50',
                color: footerData?.color || 'white',
            }}>
                <div className='container'>
                    <MDBRow className=''>
                        <MDBCol sm={12} md={6}>
                            <div className='footer-address'>
                                <img
                                    src={bussinessinfo?.logourl ? bussinessinfo?.logourl : BrandLogo}
                                    alt="" />
                                <div className='d-flex align-items-center  mt-2'>
                                    <div className='fs-2 me-3'>
                                        <i class="fas fa-map-marker-alt opacity-50"></i>
                                    </div>
                                    <div>
                                        {(bussinessinfo?.address || bussinessinfo?.city || bussinessinfo?.state || bussinessinfo?.country) ? <p className='m-0' style={{ lineHeight: '1.6' }}>

                                            {[
                                                bussinessinfo?.address,
                                                bussinessinfo?.city,
                                                bussinessinfo?.state,
                                                bussinessinfo?.country
                                            ].filter(Boolean).join(", ")}
                                        </p> : <p className='m-0'>Sundaraiah Vignana Kendram, Survey No 91,
                                            Gachibowli Rd, Madhava Reddy Colony,
                                            Gachibowli, Hyderabad, Telangana 500032</p>
                                        }
                                    </div>
                                </div>
                            </div>

                        </MDBCol>
                        <MDBCol sm={12} md={3}>
                            <div>
                                <h4 className='contact-titlename'>Contact Us</h4>
                            </div>
                            <div>
                                <ul className='footer-ul'>
                                    <li className='footer-list'><i class="fas fa-phone-alt opacity-50"></i> <span className='ms-2'> <a href="tel:+918015296362" style={{ color: 'white' }}>{bussinessinfo?.contactNumber
                                        ? bussinessinfo?.contactNumber
                                        : "+918015296362"}</a></span></li>
                                    <li className='footer-list'><i class="fas fa-envelope opacity-50"></i><span className='ms-2'><a href={`mailto:${bussinessinfo?.businessEmail ? bussinessinfo?.businessEmail : "sales@easymembr.com"}`}> {bussinessinfo?.businessEmail
                                        ? bussinessinfo?.businessEmail
                                        : "sales@easymembr.com"}</a></span></li>

                                    <li className='footer-list'></li>
                                </ul>
                            </div>
                        </MDBCol>
                        <MDBCol sm={12} md={3}>
                            <div>
                                <h4 className='contact-titlename'>Company </h4>
                            </div>
                            <div>
                                <ul className='footer-ul'>
                                    <li className='footer-list'><i class="fas fa-shield-alt opacity-50"></i> <span className='ms-2'><a href="/privacypolicy"> Privacy policy</a> </span></li>
                                    <li className='footer-list'><i class="fas fa-ban opacity-50"></i><span className='ms-2'> <a href="/termsandconditions"> Terms and Conditions</a></span></li>
                                    <li className='footer-list'> </li>
                                </ul>
                            </div>
                        </MDBCol>
                        <MDBCol sm={12} md={12}>
                            <div className='social-title'>
                                <h5><label className='bg-title' style={{ backgroundColor: footerData?.backgroundcolor }}> Follow us</label></h5>
                                <span className='line-devied'></span>
                            </div>
                        </MDBCol>
                        <MDBCol sm={12} md={12}>
                           
                            <div className='social-media'>
                                {footerData?.links
                                    ?.filter(link => typeof link === 'object' && link.check && link.label)
                                    .map((link, index) => {
                                        const iconMap = {
                                            facebook: 'facebook-f',
                                            twitter: 'twitter',
                                            youtube: 'youtube',
                                            whatsapp: 'whatsapp',
                                            instagram: 'instagram',
                                            linkedin: 'linkedin-in'
                                        };

                                        const icon = iconMap[link.label.toLowerCase()] || link.label.toLowerCase();

                                        return (
                                            <a
                                                key={index}
                                                href={link.url || '#'}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className='mx-2 '
                                            >
                                                <i className={`fab fa-${icon}`}></i>
                                            </a>
                                        );
                                    })}
                            </div>
                        </MDBCol>
                    </MDBRow>
                </div>
            </div>
        </>
    )
}

export default GymFooter
